import {
  downloadTemplate,
  getTemplateCount,
  getTemplates,
  Template,
} from "@/api/openapi";
import { PspContext } from "@/config/contexts";
import { useIsTablet } from "@/config/hooks";
import { translate } from "@/config/translator";
import { downloadBlob } from "@/config/utils";
import { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";

const LIMIT = 50;

export function useTemplatesAndInstructions() {
  const isTablet = useIsTablet();
  const { lang } = useContext(PspContext);

  const [templates, setTemplates] = useState<Template[]>();
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState<number>();
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    getTemplates({
      query: { limit: LIMIT, offset: page * LIMIT, filter_string: searchQuery },
    }).then(({ data, error }) => {
      if (error) {
        toast(translate("somethingWentWrong", lang));
      } else {
        setTemplates(data);
      }
    });
  }, [lang, page, searchQuery]);

  useEffect(() => {
    getTemplateCount({ query: { filter_string: searchQuery } }).then(
      ({ data, error }) => {
        if (error) {
          toast(translate("somethingWentWrong", lang));
        } else {
          setTotalPages(Math.ceil(data / LIMIT) || 1);
        }
      },
    );
  }, [lang, searchQuery]);

  function onDownloadTemplate(templateId: string) {
    downloadTemplate({
      path: { template_id: templateId },
      responseType: "blob",
    }).then((response) => {
      if (response.error) {
        toast(translate("somethingWentWrong", lang));
      } else {
        downloadBlob(response);
      }
    });
  }

  return {
    isTablet,
    templates,
    page,
    totalPages,
    onDownloadTemplate,
    setPage,
    searchQuery,
    setSearchQuery,
  };
}
